import React from 'react';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';

const PdfLoading = () => {
    return (
        <div className={'pdfLoader'}>
            <Spinner id="orders-pdfLoading-pdfLoading-loadingSpinner" small />
        </div>
    );
};

export default PdfLoading;
